/* DeviceDiscoveryStatusRenderer.js */

"use strict";
const discoveryStatuses = require("../../deviceConstants").DEVICE_DISCOVERY_STATUSES;

class DeviceDiscoveryStatusColumnRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("device-discovery-status-column");
        this._rootElem.component = this._model;
        this._discoveryStatuses = discoveryStatuses;
        this._statusIcon = document.createElement("base-icon-gl");

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _shutdown() {
        return new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();

            this._statusIcon.remove();
            this._statusIcon = undefined;
            this._discoveryStatuses = undefined;
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
    }

    _registerListeners() {
        this._model.on("DiscoveryStatus", (this._onDiscoveryStatus = this._onDiscoveryStatus.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeAllListeners("DiscoveryStatus");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */

    render() {
        return new Promise((resolve /*,reject*/) => {
            this._setDiscoveryStatus(this._model.getDiscoveryStatus());
            resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onDiscoveryStatus(newVal) {
        this._setDiscoveryStatus(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _setDiscoveryStatus(newVal = "UNKNOWN") {
        const discoveryStatus = this._discoveryStatuses[newVal];
        if (discoveryStatus) {
            this._updateIcon(discoveryStatus);
            if (!this._rootElem.contains(this._statusIcon)) {
                this._rootElem.innerHTML = "";
                this._rootElem.appendChild(this._statusIcon);
            }
        } else {
            this._rootElem.innerHTML = newVal;
        }
    }

    _updateIcon({ icon = "", title = "" } = {}) {
        this._statusIcon.dataset.icon = icon;
        this._statusIcon.setAttribute("title", title);
        this._statusIcon.setInvalid(icon === "common.error");
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = DeviceDiscoveryStatusColumnRenderer;
